import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "time", "shortTime", "studentChoice", "choiceDropdown"]
  static values = { baseMinutes: Number, minutesPerChoice: Number }

  open(event) {
    this.application.getControllerForElementAndIdentifier(this.modalTarget, "railsui-modal")?.show(event)
  }

  updateStudentChoice(event) {
    const count = Number(event.target.value) || 0
    const total = this.baseMinutesValue + count * this.minutesPerChoiceValue
    const duration = `${Math.floor(total / 60)}h ${String(total % 60).padStart(2, "0")}`

    this.timeTargets.forEach((target) => { target.textContent = `${duration}min` })
    this.shortTimeTargets.forEach((target) => { target.textContent = `${duration}m` })
    this.studentChoiceTargets.forEach((target) => { target.textContent = `${count} Student Choice Cases` })
    this.choiceDropdownTargets
      .filter((dropdown) => !dropdown.contains(event.target))
      .forEach((dropdown) => {
        this.application.getControllerForElementAndIdentifier(dropdown, "railsui-dropdown-menu")
          ?.selectValue(count ? String(count) : "", { emitChange: false })
      })
  }
}
